export var REGEX_ALL_DOTS = /\./g;
export var REGEX_ALL_PIPES = /\|/g;
//# sourceMappingURL=utils-regex.js.map